import { useQuery } from "@tanstack/react-query";
import { leadService } from "../services/leadService";

export const useLeadActivityStats = (params = {}) => {
  return useQuery({
    queryKey: ["Verve-lead-activity-stats", params],
    queryFn: () => leadService.getActivityStats(params),
  });
};
